

















import { Component, Mixins, Prop } from "vue-property-decorator";
import { ObjectSelectableContentOptionMixin } from "./mixins";
import { QuotedBadge } from "./common";

@Component({
  components: {
    QuotedBadge,
  }
})
export default class WizardContentRadioSelectorOption extends Mixins(ObjectSelectableContentOptionMixin) {
  @Prop()
  scale: number;
}
